@use "../../../../tti-design-styles/src/molecules/breadcrumbs/" as *;


::slotted(atlantis-breadcrumb-item:not(:first-of-type))::before {
    content: '/';
    color: var(--tti-breadcrumbs-item-text-active-color);
}

::slotted(atlantis-breadcrumb-item:nth-of-type(3))::before {
    content: '/';
    padding-right: 0.5rem;
    color: var(--tti-breadcrumbs-item-text-active-color);
}

::slotted(*) {
    display: flex !important;
    align-items: center;
}

atlantis-icon{
    padding-right: 7px;
}